import { computed, inject, Injectable, signal } from '@angular/core';
import { OLR_VERSION } from '@common';
import { ContentDictionaryMapping } from '../../models/content-dictionary-mapping.type';
import { ContentDictionary } from '../../models/content-dictionary.type';
import { DOMAIN_ID } from '../../tokens/domain-id.token';
import { mergeContentDictionaryMappings } from '../../utils/content-dictionary.utils';

@Injectable({ providedIn: 'root' })
export class ContentDictionaryService<
  T extends ContentDictionary = ContentDictionary,
> {
  private readonly domainId = inject(DOMAIN_ID);
  private readonly olrVersion = inject(OLR_VERSION);

  private readonly _contentDictionaryMapping = signal<
    ContentDictionaryMapping<T>
  >({});

  private readonly _contentDictionary = computed<T | undefined>(
    () => this._contentDictionaryMapping()[this.olrVersion]?.[this.domainId],
  );

  registerContentDictionaryMapping(
    ...contentDictionaryMapping: ContentDictionaryMapping<T>[]
  ): void {
    const merged = mergeContentDictionaryMappings(
      this._contentDictionaryMapping(),
      ...contentDictionaryMapping,
    );
    this._contentDictionaryMapping.set(merged);
  }

  get contentDictionary(): T | undefined {
    return this._contentDictionary();
  }
}
